import { CollectionItem, FullItems } from "@/api";
import { useCallback } from "react";
import { ITEM_TYPE_COLLECTION, ITEM_TYPE_VIDEO } from "@/const.ts";

/*
 * This is just a wrapper around the FullItems data format to make it easier to retrieve a single video or collection
 */

export const useFullItems = (fullItems: FullItems) => {
  const getFullItem = useCallback(
    (item: Pick<CollectionItem, "ChildId" | "Type">) => {
      let content = undefined;

      if (item.Type === ITEM_TYPE_COLLECTION) {
        content = fullItems.collections[parseInt(item.ChildId)];
      }
      if (item.Type === ITEM_TYPE_VIDEO) {
        content = fullItems.videos[parseInt(item.ChildId)];
      }
      if (!content) {
        console.debug("useFullItems", "Unable to find full item", {
          childId: item.ChildId,
        });
      }

      return content;
    },
    [fullItems],
  );

  return { getFullItem };
};
